import { SVGAttributes } from "react";

export default (props: SVGAttributes<any>) => {
  return (
    <>
      <svg {...props} width="130" height="130" viewBox="0 0 130 130" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M119.855 65C119.855 85.0503 109.039 102.677 92.9242 112.151C92.9242 112.151 92.8138 112.261 92.7034 112.261C91.5997 112.922 90.496 113.473 89.3922 114.024C88.8404 114.355 88.2885 114.575 87.7366 114.795C87.5159 114.905 87.2952 115.016 87.0744 115.126H86.964C86.7433 115.236 86.4122 115.346 86.1914 115.456C84.5359 116.227 82.7699 116.778 81.0039 117.329C80.7832 117.439 80.4521 117.549 80.2313 117.549C80.121 117.549 80.0106 117.66 79.9002 117.66C79.7898 117.66 79.6795 117.66 79.6795 117.77C79.5691 117.77 79.4587 117.77 79.3484 117.88C77.0305 118.541 74.6023 118.982 72.0638 119.312C69.746 119.643 67.4281 119.753 65.1103 119.753C61.3577 119.753 57.7154 119.422 54.1835 118.651C53.9627 118.651 53.742 118.541 53.5212 118.541C52.7486 118.431 51.976 118.21 51.2034 117.99C50.4308 117.77 49.6582 117.549 48.8856 117.329C45.7952 116.338 42.7047 115.126 39.8351 113.694C22.1755 104.55 10.1449 86.152 10.1449 65C10.1449 34.7041 34.7579 10.2471 64.9999 10.2471C95.3523 10.2471 119.855 34.7041 119.855 65Z"
          fill="var(--blue-05)"
        />
        <path d="M108.366 28.3556L108.425 35.1463" stroke="var(--blue-1)" strokeLinecap="round" />
        <path d="M111.791 31.7215L105 31.7801" stroke="var(--blue-1)" strokeLinecap="round" />
        <path d="M109.676 28.0002L109.733 34.5914" stroke="#FB8149" strokeLinecap="round" />
        <path d="M113 31.2671L106.409 31.3239" stroke="#FB8149" strokeLinecap="round" />
        <path d="M26.3547 102.642L26.4304 111.427" stroke="var(--blue-1)" strokeWidth="1.5" strokeLinecap="round" />
        <path d="M30.7854 106.997L21.9999 107.072" stroke="var(--blue-1)" strokeWidth="1.5" strokeLinecap="round" />
        <path d="M28.1528 102L28.2285 110.785" stroke="#FB8149" strokeWidth="1.5" strokeLinecap="round" />
        <path d="M32.5835 106.355L23.798 106.43" stroke="#FB8149" strokeWidth="1.5" strokeLinecap="round" />
        <rect x="14.5" y="40.5" width="31.38" height="12.3701" rx="1.5" fill="#C3D6FC" stroke="#4584FF" />
        <rect x="14.5" y="58.4109" width="31.38" height="12.3701" rx="1.5" fill="#C3D6FC" stroke="#4584FF" />
        <rect x="14.7145" y="76.3217" width="31.38" height="12.3701" rx="1.5" fill="#C3D6FC" stroke="#4584FF" />
        <rect x="48.8099" y="40.5" width="31.38" height="12.3701" rx="1.5" fill="#C3D6FC" stroke="#4584FF" />
        <rect x="48.8099" y="58.4109" width="31.38" height="12.3701" rx="1.5" fill="#C3D6FC" stroke="#4584FF" />
        <rect x="49.0244" y="76.3217" width="31.38" height="12.3701" rx="1.5" fill="#C3D6FC" stroke="#4584FF" />
        <rect x="83.3344" y="40.5" width="30.9512" height="12.3701" rx="1.5" fill="#C3D6FC" stroke="#4584FF" />
        <rect x="83.3344" y="58.4109" width="30.9512" height="12.3701" rx="1.5" fill="#C3D6FC" stroke="#4584FF" />
        <rect x="83.5488" y="76.3217" width="30.9512" height="12.3701" rx="1.5" fill="#C3D6FC" stroke="#4584FF" />
        <path
          d="M62.9113 86.1638L63.74 95.191C63.7726 95.5459 64.1595 95.7552 64.4765 95.5894L65.942 94.8233C66.1867 94.6954 66.4909 94.7889 66.6215 95.0322L68.2281 98.0265C68.3587 98.2698 68.6629 98.3633 68.9076 98.2354L70.4752 97.4159C70.7199 97.2879 70.8125 96.9869 70.6819 96.7436L69.0753 93.7494C68.9448 93.5061 69.0373 93.2051 69.282 93.0772L70.7475 92.311C71.0645 92.1453 71.1065 91.7117 70.8274 91.4857L63.7278 85.7369C63.3827 85.4575 62.871 85.725 62.9113 86.1638Z"
          fill="var(--blue-9)"
        />
        <mask id="path-20-inside-1_808_14" fill="white">
          <path d="M91.7591 21.1896L90.1975 22.8628C89.936 23.143 89.4687 23.0367 89.354 22.6708L88.14 18.8015" />
        </mask>
        <path
          d="M91.7591 21.1896L90.1975 22.8628C89.936 23.143 89.4687 23.0367 89.354 22.6708L88.14 18.8015"
          fill="#D66430"
        />
        <path
          d="M90.1975 22.8628L89.4652 22.1809L90.1975 22.8628ZM91.0268 20.5077L89.4652 22.1809L90.9298 23.5448L92.4914 21.8715L91.0268 20.5077ZM90.3087 22.373L89.0947 18.5037L87.1852 19.0993L88.3992 22.9686L90.3087 22.373ZM89.4652 22.1809C89.7267 21.9008 90.194 22.0071 90.3087 22.373L88.3992 22.9686C88.7435 24.0662 90.1453 24.3853 90.9298 23.5448L89.4652 22.1809Z"
          fill="#D66430"
          mask="url(#path-20-inside-1_808_14)"
        />
        <path
          d="M88.4244 18.3902L88.4179 18.3857L88.4112 18.3814L85.1402 16.2716L104.302 9.76714L104.306 9.76603L105.044 9.52123L94.8305 22.5904L89.4108 19.0716L88.4244 18.3902Z"
          fill="#FB8149"
          stroke="#FB8149"
        />
        <path
          d="M104.354 9.74838L104.663 9.64574L89.152 18.8911L89.0656 18.8314L104.354 9.74838Z"
          fill="#7E3B1C"
          stroke="#D66430"
        />
        <path
          d="M55 38C56.335 35.8549 57.6904 33.4789 64.6992 32.1745C73.8123 30.4784 82.3578 29.2178 87 24"
          stroke="#AAC2EF"
          strokeWidth="0.5"
          stroke-dasharray="3 3"
        />
      </svg>
    </>
  );
};
